/* eslint-disable no-undef */
import axios, {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse,
  CancelTokenSource,
  InternalAxiosRequestConfig,
} from "axios";
import { SUCCESS, FORBIDDEN, TOKEN_EXPIRED } from "./status";
import OAuth2Helper from "./oauth2-helper";
import { URL_PATHS } from "./url-paths";
import { APP_CONFIGS } from "../configs/app-configs";
import EventBus, { EventBusName } from "../eventbus/event-bus";
import localStorageHelpers, {
  StorageKey,
} from "../storage/local-storage-helpers";
import { LoginMobileResponse } from "src/libraries/types/login";
import Base64 from "src/libraries/utils/base64";
const REFRESH_THRESHOLD = 5 * 60; // Làm mới token 5 phút trước khi hết hạn
const instance = axios.create({
  baseURL: APP_CONFIGS.GATEWAY_URL,
  timeout: 120 * 1000,
});

//instance.interceptors.request.use((_config) => requestHandler(_config));
var env: any = null;
// try {
//   env = require("react-native-config");
// } catch {}

const ENV: string =
  process.env.REACT_APP_ENV_STATUS ||
  env?.Config?.REACT_APP_ENV_STATUS ||
  "PRODUCTION";
const requestHandler = (request: AxiosRequestConfig) => {
  // if (__DEV__) {
  console.log(
    `Request API - ${request.method?.toUpperCase()}: ${request.baseURL}${
      request.url
    }`,
    request.params,
    request.data
  );
  // }

  return request;
};
const decodeJwt = (accessToken: string) => {
  try {
    let base64Url = accessToken.split(".")[1];
    let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    let jsonPayload = decodeURIComponent(
      Base64.atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    return null;
  }
};

instance.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    let accessToken = localStorageHelpers.get(StorageKey.ACCESS_TOKEN);
    let tokenData = decodeJwt(accessToken);
    console.log(tokenData);

    if (!accessToken) {
      // Không có token => chuyển về trang đăng nhập
      window.location.href = "/login";
      return Promise.reject("No access token found");
    }

    // const isTokenValid = await introspectToken(accessToken);
    // if (!isTokenValid) {
    //   localStorageHelpers.remove(StorageKey.ACCESS_TOKEN);
    //   window.location.href = "/login";
    //   return Promise.reject("Session expired");
    // }

    let expiryTime = tokenData ? tokenData.exp : null;
    const now = Math.floor(Date.now() / 1000); // đổi về giây
    // console.log(expiryTime);
    // console.log(now);
    if (expiryTime && expiryTime - now <= REFRESH_THRESHOLD) {
      const newToken = await getRefreshToken(accessToken);
      if (!newToken) {
        // Không có token => chuyển về trang đăng nhập
        console.log("Lấy token refresh failed");
        window.location.href = "/login";
        return Promise.reject("Failed to get refresh token");
      } else {
        config.headers.Authorization = `Bearer ${newToken}`;
      }
    } else {
      // Sử dụng token hiện tại
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      window.location.href = "/login";
      return Promise.reject("Failed to get refresh token");
      // try {
      //   let accessToken = localStorageHelpers.get(StorageKey.ACCESS_TOKEN);
      //   // const newToken = await getRefreshToken(accessToken);
      //   // if (!newToken) {
      //     //Không có token => chuyển về trang đăng nhập
      //     console.log("Lấy token refresh failed");
      //   //}
      //   localStorageHelpers.save(StorageKey.ACCESS_TOKEN, newToken);
      //   originalRequest.headers.Authorization = `Bearer ${newToken}`;
      //   return instance(originalRequest); // Gửi lại yêu cầu gốc
      // } catch (err) {
      //   console.error("Unable to refresh token:", err);
      //   return Promise.reject(err);
      // }
    }

    //return Promise.reject(error);
  }
);

/// -----
// const instance2 = axios.create({
//   baseURL: APP_CONFIGS.REACT_APP_POST_FILE,
//   // baseURL: url,
//   timeout: 20 * 1000,
// });

// instance2.interceptors.request.use((_config) => requestHandler(_config));

// instance2.interceptors.response.use(
//   (response) => successHandler(response),
//   (error) => errorHandler(error)
// );

////
const getRefreshToken = async (accessToken: string): Promise<string | null> => {
  try {
    const res = await axios.post(
      `${APP_CONFIGS.GATEWAY_URL}${URL_PATHS.REFRESH_TOKEN}`,
      { token: accessToken }
      // { headers: { Authorization: `Bearer ${accessToken}` } }
    );
    let refreshToken = null;
    if (res && res.data.code === 1000) {
      refreshToken = res.data.result.token;
      localStorageHelpers.save(StorageKey.ACCESS_TOKEN, refreshToken);
      console.log("Access token refreshed successfully.");
    } else {
      window.location.href = "/login";
      return Promise.reject("Failed to get refresh token");
    }
    return refreshToken;
  } catch (error) {
    return Promise.reject("Failed to get refresh token");
  }
};

// Hàm introspect token
const introspectToken = async (accessToken: string): Promise<boolean> => {
  try {
    const response = await axios.post(
      `${APP_CONFIGS.GATEWAY_URL}${URL_PATHS.INTROSPECT_TOKEN}`,
      {
        token: accessToken,
      }
    );
    return response.data.result.valid;
  } catch (error) {
    console.error("Error introspecting token:", error);
    return false;
  }
};
const errorHandler = async (error: any) => {
  if (error.response?.status === TOKEN_EXPIRED) {
    const originalRequest = error.config;
    const newAccessToken = await OAuth2Helper.getInstance().getAccessToken(
      true
    );
    originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
    return await instance(originalRequest);
    //console.log("redirecting");
    //const url = APP_CONFIGS.REDIRECT_URL + APP_CONFIGS.DOMAIN_APP;
    //console.log("REDIRECT SSO URL: ", url);

    //window.location.href = url;
  } else if (error.response?.status === FORBIDDEN) {
    EventBus.getInstance().post({
      type: EventBusName.FORBIDDEN_REQUEST,
    });
  }

  return Promise.reject({ ...error });
};

const successHandler = (response: AxiosResponse) => {
  // if (__DEV__) {
  console.log(`Response API: ${response.config.url}`, response);
  // }
  return response.data;
};

async function fetch(
  url: string,
  params?: any,
  isAuth?: boolean,
  isRaw?: boolean,
  catchErr?: boolean,
  source?: CancelTokenSource
) {
  let headers: any = null;
  // const headers: any = {
  //   API_KEY: `c713284a-3b4f-4006-9ba0-f5a9551f0a4f`,
  //   CLIENT_ID: "332c97ee-7292-4d9c-9bfc-32653ba6ee39",
  // };
  if (isAuth) {
    headers = await createHeader();
  }
  console.log("CHECKING SORUCE: ", !isRaw);
  return !isRaw
    ? instance
        .get(url, { params, headers, cancelToken: source?.token })
        .then((res) => {
          console.log("RESPONSE :", res.data);
          // checkToken(res);
          return res;
        })
    : axios
        .create({
          baseURL: `${APP_CONFIGS.GATEWAY_URL}`,
          timeout: 20 * 1000,
        })
        .get(url, { params, headers })
        .then((res) => {
          console.log("test_fetch_raw_success: ", res);
          return res;
        })
        .catch((error) => {
          console.log("test_fetch_raw_fail: ", error);
        });
}

async function post(
  url: string,
  data?: any,
  isAuth?: boolean,
  isRaw?: boolean,
  catchErr?: boolean
) {
  let headers: any = null;
  if (isAuth) {
    headers = await createHeader();
  }
  return !isRaw
    ? instance.post(url, data, { headers }).then((res) => checkToken(res))
    : // .catch((error) => {
      //   console.log("catch_err_post: ", error.response.data);
      //   if (catchErr) {
      //     return error.response.data;
      //   }
      // })
      axios
        .create({
          baseURL: `${APP_CONFIGS.GATEWAY_URL}`,
          timeout: 20 * 1000,
        })
        .post(url, data, { headers })
        .then((res) => {
          console.log("test_post_raw_success: ", res);
          return res;
        });
  // console.log("đã chạy vào đây");
  // return {
  //   code: 1000,
  //   result: {
  //     authenticated: true,
  //     token: "none",
  //   },
  // };
}
async function postRaw(
  url: string,
  data?: any,
  isAuth?: boolean,
  isRaw?: boolean,
  catchErr?: boolean
) {
  let headers: any = null;
  if (isAuth) {
    headers = await createHeader();
  }
  return !isRaw
    ? instance
        .post(url, data, {
          headers: { ...headers, "Content-Type": "text/plain" },
        })
        .then((res) => checkToken(res))
    : // .catch((error) => {
      //   console.log("catch_err_post: ", error.response.data);
      //   if (catchErr) {
      //     return error.response.data;
      //   }
      // })
      axios
        .create({
          baseURL: "",
          timeout: 20 * 1000,
        })
        .post(url, { data, headers })
        .then((res) => {
          console.log("test_post_raw_success: ", res);
          return res;
        });
}
async function postParams(
  url: string,
  data?: any,
  isAuth?: boolean,
  isRaw?: boolean,
  catchErr?: boolean
) {
  let headers: any = null;
  if (isAuth) {
    headers = await createHeader();
  }
  return !isRaw
    ? instance
        .post(url, null, { headers, params: data })
        .then((res) => checkToken(res))
    : // .catch((error) => {
      //   console.log("catch_err_post: ", error.response.data);
      //   if (catchErr) {
      //     return error.response.data;
      //   }
      // })
      axios
        .create({
          baseURL: "",
          timeout: 20 * 1000,
        })
        .post(url, { data, headers })
        .then((res) => {
          console.log("test_post_raw_success: ", res);
          return res;
        });
}

async function uploadImage(data: any) {
  let headers = {
    Accept: "application/json",
    "Content-Type": "multipart/form-data",
  };
  return await axios({
    method: "POST",
    // url: APP_CONFIGS.URL_API + URL_PATHS.UPLOAD_FILE,
    headers: headers,
    data: data,
  }).catch((error) => {
    console.log("LOG ERROR UPLOAD IMAGE : ", error);
    EventBus.getInstance().post({
      type: EventBusName.ERROR,
      payload: {
        message: error?.response?.data?.message,
      },
    });
  });
}

async function postForm(
  url: string,
  data?: any,
  isAuth?: boolean,
  isRaw?: boolean
) {
  let headers: any = null;
  if (isAuth) {
    // headers = await createHeader();
    // headers["Content-Type"] = "multipart/form-data";
    headers = { "Content-Type": "multipart/form-data" };
  }
  return !isRaw
    ? instance
        .post(url, { ...data }, { headers })
        .then((res) => checkToken(res))
        .catch((error) => console.log(error))
    : axios
        .create({
          baseURL: "",
          timeout: 20 * 1000,
        })
        .post(url, { data, headers })
        .then((res) => {
          console.log("test_post_raw_success: ", res);
          return res;
        })
        .catch((error) => {
          console.log("test_post_raw_fail: ", url, "__", data, "__", headers);
          console.log("test_post_raw_fail_1: ", error);
        });
}

async function getFile(
  url: string,
  data?: any,
  isAuth?: boolean,
  isRaw?: boolean
) {
  let headers: any = null;
  if (isAuth) {
    headers = await createHeader();
  }
  console.log("DEBUG333", isRaw);

  return !isRaw
    ? instance
        .get(url, { headers, responseType: "blob" })
        .then((res) => checkToken(res))
        .catch((error) => console.log(error))
    : axios
        .create({
          baseURL: "",
          timeout: 20 * 1000,
          responseType: "blob",
        })
        .get(url, { data, headers })
        .then((res) => {
          console.log("test_post_raw_success: ", res);
          return res;
        })
        .catch((error) => {
          console.log("test_post_raw_fail: ", url, "__", data, "__", headers);
          console.log("test_post_raw_fail_1: ", error);
        });
}

async function postFile(
  url: string,
  data?: any,
  isAuth?: boolean,
  isRaw?: boolean,
  catchErr?: boolean
) {
  let headers: any = null;
  if (isAuth) {
    headers = await createHeader();
  }
  console.log("DEBUG333", isRaw);

  return !isRaw
    ? instance
        .post(url, data, { headers, responseType: "blob" })
        .then((res) => checkToken(res))
        .catch((error) => {
          console.log("ERROR EXCEL", error);

          if (catchErr) {
            return error;
          }
        })
    : axios
        .create({
          baseURL: "",
          timeout: 20 * 1000,
          responseType: "blob",
        })
        .get(url, { data, headers })
        .then((res) => {
          console.log("test_post_raw_success: ", res);
          return res;
        })

        .catch((error) => {
          console.log("test_post_raw_fail: ", url, "__", data, "__", headers);
          console.log("test_post_raw_fail_1: ", error);
          return error;
        });
}

async function deletes(
  url: string,
  data?: any,
  isAuth?: boolean,
  catchErr?: boolean
) {
  let headers = null;
  if (isAuth) {
    headers = await createHeader();
  }

  return instance
    .delete(url, { data: data, headers: { ...headers } })
    .then((res) => checkToken(res));
  // .catch((error) => {
  //   if (catchErr) {
  //     return error.response.data;
  //   }
  // });
}
async function put(url: string, data?: any, isAuth?: boolean) {
  let headers: any = null;
  if (isAuth) {
    headers = await createHeader();
  }

  return instance
    .put(url, { ...data }, { headers })
    .then((res) => checkToken(res));
  // .catch((error) => error.response.data);
}
async function putRaw(url: string, data?: any, isAuth?: boolean) {
  let headers = null;
  if (isAuth) {
    headers = await createHeader();
  }

  return instance
    .put(
      url,
      { ...data },
      { headers: { ...headers, "Content-Type": "text/plain" } }
    )
    .then((res) => checkToken(res));
  // .catch((error) => error.response.data);
}
async function createHeader(): Promise<object> {
  var accessToken = await OAuth2Helper.getInstance().getAccessToken();
  // var accessToken = await localStorageHelpers.get(StorageKey.ACCESS_TOKEN);
  // const refreshToken = await localStorageHelpers.get(StorageKey.REFRESH_TOKEN);
  const lang = await localStorageHelpers.get(StorageKey.LANGUAGE);
  //if (isExpiredToken(accessToken)) {

  //console.log('test_refresh_token_0');

  //if (refreshToken) {
  //const response = await getTokenByRefreshToken(refreshToken);
  //console.log('test_refresh_token_rs', response);
  //if (response && response.status === SUCCESS) {
  //accessToken = response.data.access_token;

  //await localStorageHelpers.remove(StorageKey.ACCESS_TOKEN);
  //await localStorageHelpers.remove(StorageKey.REFRESH_TOKEN);
  //await localStorageHelpers.save(StorageKey.ACCESS_TOKEN,response.data.access_token )
  //await localStorageHelpers.save(StorageKey.REFRESH_TOKEN,response.data.refresh_token )

  //} else {
  ////showAlert(TYPE.ERROR, 'get refresh token error');
  ////navigationService.navigate(screenName.AuthenNavigator);
  //EventBus.getInstance().post({
  //type: EventBusName.EXPIRE_TOKEN,
  //payload: 'refresh token'
  //})
  //}
  //} else {
  //EventBus.getInstance().post({
  //type: EventBusName.EXPIRE_TOKEN,
  //payload: 'refresh token'
  //})
  //return {};
  //}
  //}
  const headers: any = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json",
    "Content-Language": lang,
    // API_KEY: `c713284a-3b4f-4006-9ba0-f5a9551f0a4f`,
    // CLIENT_ID: "332c97ee-7292-4d9c-9bfc-32653ba6ee39",
  };

  console.log("test_header: ", { ...headers, "Content-Type": "text/plain" });

  return headers;
}

//export async function removeUser(): Promise<void> {
//// await localStorageHelpers.remove(StorageKey.USER_INFO);
//// return Promise.resolve();
//}

async function getUserInfo(): Promise<any> {
  const res = JSON.parse(
    (await localStorageHelpers.get(StorageKey.USER_INFO)) as string
  );
  return Promise.resolve(res);
}

// TODO
export function checkToken(res: any) {
  console.debug("TEXT RES", res);

  // if (res && res.code === TOKEN_EXPIRED) {
  //   return new Promise<Object>((resolve, reject) => {
  //     Alert.alert(
  //       translate('notify'),
  //       translate('tokenInvalid'),
  //       [{ text: translate('common.yes'), onPress: () => {} }],
  //       { cancelable: false }
  //     );
  //   });
  // } else return res;
  return res;
}

export async function InvalidToken(error: any) {
  const setting: any = await getUserInfo();
  console.log("SETTING: ", setting);
  var accessToken = setting ? setting.accessToken : "";
  var user = setting.user;
  console.log("GET REFRESH TOKEN : ");

  // if (APP_CONFIGS.LOGIN_SSO === 'true') {
  //   console.log(error);
  if (error && error.response?.status === 401) {
    if (setting?.refreshToken) {
      const response = await getTokenByRefreshToken(setting?.refreshToken);
      if (response && response?.status === SUCCESS) {
        const data: LoginMobileResponse = {
          user: user,
          accessToken: response.data.access_token,
          refreshToken: response.data.refresh_token,
        };
        localStorageHelpers.remove(StorageKey.USER_INFO);
        localStorageHelpers.save(StorageKey.USER_INFO, JSON.stringify(data));
      } else {
        // showAlert(TYPE.ERROR, 'get refresh token error');
        // navigationService.navigate(screenName.AuthenNavigator);
      }
    } else {
      // showAlert(TYPE.ERROR, 'get refresh token error');
      // navigationService.navigate(screenName.AuthenNavigator);
    }
    return error;
  }
  // else {
  //   return error;
  // }
  // }
}

const getTokenByRefreshToken = async (refreshToken: string) => {
  let data = new URLSearchParams();
  data.append("refresh_token", refreshToken);
  data.append("client_id", "web");
  data.append("grant_type", "refresh_token");

  try {
    const response = await axios({
      method: "POST",
      url: APP_CONFIGS.GET_TOKEN_SERVER,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: data,
      timeout: 30000,
    });

    return response;
  } catch (error) {
    console.log("test_getTokenByRefreshToken: ", error);
  }
};

export async function getTokenUrl() {
  // return GET_TOKEN_URL_PREFIX + getRealms() + GET_TOKEN_URL_SUFFIX;
  // return 'https://keycloak.hyperlogy.com/auth/realms/ihcm/protocol/openid-connect/token';
  const domain =
    (await localStorageHelpers.get(StorageKey.DOMAIN_COMPANY)) || "";
  const tenant = domain.replace(".ihcm.vn", "");
  return APP_CONFIGS.GET_TOKEN_SERVER.replace("@tanent", tenant);
}

async function fetchVietQrLPResult(
  url: string,
  params?: any,
  isAuth?: boolean,
  source?: CancelTokenSource
) {
  let headers: any = null;
  if (isAuth) {
    headers = await createHeader();
  }
  return axios
    .get(APP_CONFIGS.GATEWAY_URL + url, {
      cancelToken: source?.token,
      params,
      headers,
    })
    .then((res) => {
      console.log("RESPONSE :", res.data);
      // checkToken(res);
      return res;
    });
}

export {
  introspectToken,
  fetch,
  post,
  put,
  postForm,
  deletes,
  uploadImage,
  getFile,
  postFile,
  postParams,
  postRaw,
  putRaw,
  fetchVietQrLPResult,
  createHeader,
};
